import styled from 'styled-components';

export const MapSection = styled.div`
  // padding-left: 400px;
  // padding-top: 10px;
  // top: 192px;

  width: ${props => (props.isDestinationSelected ? '51%' : '67%')};
  height: calc(100vh - 175px);
  z-index: 0;

  left: 288px;
  position: fixed;

  /* width: ${props => (props.isDestinationSelected ? '67%' : '83%')}; */
  /* left: 288px; */

  // padding-left: 290px;
  // padding-right: 305px;
`;
